import { AccountFeature } from 'app/constants/constants';
import { Account } from 'app/providers/bridge-api/account.service';
import { AccountDetails } from 'app/providers/semantria-api/semantria-account.service';

export class AccountUtils {
  static hasFeature(account: Account | AccountDetails, feature: AccountFeature): boolean {
    return account.features.includes(feature);
  }

  static hasExternalResource(
    accountDetails: AccountDetails,
    id?: string,
    name?: string,
    type?: string
  ): boolean {
    if (!id && !name && !type) {
      throw new Error('id, name, or type must be provided.');
    }

    return accountDetails.external_resources?.some(
      (externalResource) =>
        (!id || externalResource.external_id === id) &&
        (!name || externalResource.external_name === name) &&
        (!type || externalResource.external_type === type)
    );
  }
}
